/**
 * Created by andrey on 19.05.2022.
 */

const CenterHint = function () {
    this.onShowHint = function () {};
    this.onHideHint = function () {};
    this.onRemoveHint = function () {};
};

CenterHint.prototype.createTextHint = function (message, position) {
    this.create({
        message,
        position
    });
};

CenterHint.prototype.listAvailableHints = function () {
    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        return [
            typeof CrystalUnmergeableUnitHintContent === "undefined" ? undefined : CrystalUnmergeableUnitHintContent,
            typeof CustomerHintContent === "undefined" ? undefined : CustomerHintContent,
            typeof PointToCustomersHintContent === "undefined" ? undefined : PointToCustomersHintContent,
            typeof MissionTreeHintContent === "undefined" ? undefined : MissionTreeHintContent,
            typeof ProducerHintContent === "undefined" ? undefined : ProducerHintContent,
            typeof UnmergeableUnitHintContent === "undefined" ? undefined : UnmergeableUnitHintContent,
            typeof MergeBonusHintContent === "undefined" ? undefined : MergeBonusHintContent,
            typeof FeedableHintContent === "undefined" ? undefined : FeedableHintContent,
            TextHintContent].filter(Boolean);
    }
    return [TextHintContent];
};

CenterHint.prototype.create = function (options) {
    if (this.content && this.content.hasSameContent(options)) {
        this.hideWaitComplete = false;

        if (this.contentWasShown) {
            this.schedule(CenterHint.DURATION, this.finishCenterHint.bind(this));
        }
        return;
    }

    const availableHints = this.listAvailableHints();
    const HintContent = availableHints.filter((hintContents) => hintContents.isApplicable(options))[0];

    if (HintContent) {
        this.hideHint();
        this.hideWaitComplete = false;
        this.contentWasShown = false;

        this.content = new HintContent(options);

        const messages = this.content.getMessages();
        let position = options.position || MinimalDialogue.POSITIONS.TOP;
        if (this.content.doNotBlock) {
            const map2dView = Map2d.currentMap.getMapView();
            const centerCell = Map2d.currentMap.getScreenCenterCell();
            position = map2dView.toScreen(this.content.doNotBlock.x, this.content.doNotBlock.y).y > map2dView.toScreen(centerCell.x, centerCell.y).y ? MinimalDialogue.POSITIONS.BOTTOM : MinimalDialogue.POSITIONS.TOP;
        }

        if (options.wrongMerged || options.wrongCrystalMerged) {
            this.schedule(CenterHint.WRONG_MERGED_DELAY, this.showHint.bind(this, messages, position));
        } else {
            this.showHint(messages, position);
        }
    }
};

CenterHint.prototype.finishCenterHint = function () {
    if (this.content) {
        this.hideWaitComplete = true;

        if (this.contentWasShown) {
            this.schedule(CenterHint.DELAY_BEFORE_HIDING, this.hideHint.bind(this));
        }
    }
};

CenterHint.prototype.onCompleteAnimation = function () {
    if (this.content && this.hideWaitComplete) {
        this.hideHint();
    }
};

CenterHint.prototype.showHint = function (messages, position) {
    if (cleverapps.gameModes.silentCenterHint) {
        return;
    }

    if (this.hideWaitComplete) {
        this.hideHint();
        return;
    }

    this.contentWasShown = true;
    this.onShowHint(messages, position);
    this.schedule(CenterHint.DURATION, this.finishCenterHint.bind(this));
};

CenterHint.prototype.remove = function () {
    this.onRemoveHint();
};

CenterHint.prototype.hideHint = function () {
    this.content && this.content.onComplete && this.content.onComplete();
    this.clearTimeout();
    this.onHideHint();
    this.content = undefined;
};

CenterHint.prototype.destructor = function () {
    this.clearTimeout();
    this.content = undefined;
};

CenterHint.prototype.clearTimeout = function () {
    if (this.timeout !== undefined) {
        cleverapps.timeouts.clearTimeout(this.timeout);
        this.timeout = undefined;
    }
};

CenterHint.prototype.schedule = function (timeout, callback) {
    this.clearTimeout();
    this.timeout = cleverapps.timeouts.setTimeout(callback, timeout);
};

CenterHint.DURATION = 2500;
CenterHint.WRONG_MERGED_DELAY = 600;
CenterHint.DELAY_BEFORE_HIDING = 200;
